// Escolha da era (crônicas das guerras): cada uma traz uma regra para a mesa.
import { CHRONICLES } from '../theme';

export function EraPicker({
  value,
  onChange,
  disabled,
  bossesOn,
}: {
  value: string | null;
  onChange?: (id: string) => void;
  disabled?: boolean;
  bossesOn: boolean;
}) {
  const current = value ?? CHRONICLES[0].id;
  return (
    <div className="eras" role="radiogroup" aria-label="Era da partida">
      {CHRONICLES.map((c) => {
        const on = c.id === current;
        const needsBosses = 'bossSpawnFaces' in c.ruleset && !bossesOn;
        return (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={on}
            className={`era${on ? ' on' : ''}`}
            disabled={disabled && !on}
            onClick={() => !disabled && onChange?.(c.id)}
          >
            <span className="era-head">
              <span className="era-title">{c.title}</span>
              <span className="era-when sc">
                {c.world} · {c.period}
              </span>
            </span>
            <span className="era-rule">{c.rule}</span>
            {needsBosses && <span className="era-warn">Precisa do add-on de bosses ligado.</span>}
          </button>
        );
      })}
    </div>
  );
}
